import { Permission, userHasPermission } from '@forto-dev/auth-sdk-models'

export const hasPermission = (permissions: Permission[], permission: Permission): boolean =>
  userHasPermission(permissions, permission)
